<template>
  <div class="upload_module">
    <div>
      <el-upload
        :class="params.name"
        :ref="params.name"
        :key="params.name"
        class="opus_upload"
        :action="`${process.env.VUE_APP_CASTLE_URL}/aliyun/oss/OSSController/starrycastle-security/uploadFile`"
        :show-file-list="false"
        :data="apiParams"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
        :headers="headers"
        accept="image/*"
      >
        <div :class="{upload_area:!isPrize,upload_prize:isPrize}">
          <!-- 上传点击按钮 -->
          <div class="upload_btn">
            <div class="add_img">
              <i class="my_icon circle_add" v-if="!isPrize"></i>
              <i class="el-icon-camera-solid" v-else></i>
            </div>
            <!-- 上传作品显示提示信息 -->
            <template v-if="!isPrize">
              <h3>点击添加图片</h3>
              <p>支持jpg/gif/png格式</p>
              <p>RGB/CMYK模式，不超过1M</p>
            </template>
            <!-- 上传获奖显示提示信息 -->
            <p v-else>支持jpg/png格式RGB模式</p>
            <div class="prize_img_box" v-if="isPrize && params.img_list.length">
              <img :src="params.img_list[0].filePath" alt />
            </div>
          </div>
          <!-- 如果是上传作品图片，显示多图 -->
          <template v-if="!isPrize">
            <div
              class="img_box"
              v-for="(item, index) in params.img_list"
              :key="index"
              v-dragging="{ item: item, list: params.img_list, group: 'item' }"
            >
              <img :src="item.filePath" alt />
              <div class="close" @click.stop="deleteImg(index)">
                <i class="my_icon circle_close" v-if="!isPrize"></i>
                <i class="el-icon-close" v-else></i>
              </div>
            </div>
          </template>
        </div>
      </el-upload>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      }
    },
    //是否为获奖证明 true表示上传类型是获奖证明图片 false表示上传类型为作品图片
    isPrize: {
      type: Boolean,
      default: false
    },
    disabled: {
      //禁止使用
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      apiParams: {
        catalog: "CatalogWhaleImage"
      },
      headers: {
        token: sessionStorage.getItem("token")
      }
      // 传入参数
      // params: {
      //   img_list: [] //上传图片列表
      // }
    };
  },
  mounted() {
    //  检测拖动
    this.$dragging.$on("dragged", ({ value }) => {
      console.log(value.item);
      console.log(value.list);
      console.log(value.group);
    });
  },
  methods: {
    /*上传前的拦截 file.response 拿到服务端返回数据**/
    beforeAvatarUpload(file) {
      let size = 1; //文件大小是否合格

      const isLt2M = file.size / 1024 / 1024 < size;
      const _text = size < 1 ? size * 1024 + "KB" : size + "MB";
      if (!isLt2M) {
        this.$message.error(`上传文件大小不能超过 ${_text}!`);
      }

      return isLt2M;
    },
    handleAvatarSuccess(res) {
      let imgObj = res.obj;
      this.params.img_list.push(imgObj);
      this.$emit("uploadSucess", {
        ...this.params
      });
    },

    // 删除已选择图片
    deleteImg(index) {
      if (this.disabled) return;
      this.params.img_list.splice(index, 1);
      let name = this.params.name;
      this.$refs[name].value = "";
      this.$emit("uploadSucess", {
        ...this.params
      });
    }
  }
};
</script>
<style lang="scss">
.upload_module {
  .upload_area {
    display: flex;
    flex-wrap: wrap;
    padding-left: 10px;
    box-sizing: border-box;
    .upload_btn {
      width: 240px;
      height: 180px;
      background: rgba(245, 245, 245, 1);
      text-align: center;
      box-sizing: border-box;
      padding: 30px 40px;
      // cursor: pointer;
      margin-right: 20px;
      position: relative;
      h3 {
        font-size: 14px;
        color: #666;
        font-weight: normal;
        line-height: 34px;
      }
      p {
        font-size: 12px;
        color: #999;
        line-height: 21px;
      }
    }

    .img_box {
      display: block;
      width: 240px;
      height: 180px;
      margin-right: 20px;
      margin-bottom: 10px;
      position: relative;
      img {
        width: 240px;
        height: 180px;
      }
      .close {
        opacity: 0;
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        transition: all 0.3s;
      }
    }
    .img_box:hover {
      .close {
        opacity: 1;
      }
    }
  }
  .upload_prize {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    .upload_btn {
      width: 60px;
      height: 60px;
      border: 1px dashed rgba(230, 230, 230, 1);
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 20px;
      position: relative;
      position: relative;
      .add_img {
        color: #e6e6e6;
        font-size: 18px;
        text-align: center;
        line-height: 60px;
        margin: 0 auto;
      }
      h3 {
        font-size: 14px;
        color: #666;
        font-weight: normal;
        line-height: 34px;
      }
      p {
        font-size: 12px;
        color: #999;
        line-height: 18px;
        width: 170px;
      }
      .prize_img_box {
        display: block;
        width: 60px;
        height: 60px;
        position: absolute;
        left: 0;
        top: 0;
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
    .img_box {
      display: block;
      width: 60px;
      height: 60px;
      margin-right: 20px;
      margin-bottom: 10px;
      position: relative;
      img {
        width: 60px;
        height: 60px;
      }
      .close {
        width: 14px;
        height: 14px;
        background: rgba(52, 52, 52, 1);
        opacity: 0;
        border-radius: 50%;
        position: absolute;
        right: 3px;
        top: 3px;
        color: #fff;
        text-align: center;
        font-size: 8px;
        line-height: 16px;
        cursor: pointer;
        transition: all 0.3s;
      }
    }
    .img_box:hover {
      .close {
        opacity: 0.7;
      }
    }
  }
}
</style>
